var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", [_vm._v(_vm._s(_vm.attributeData.displayName))]),
      _c("v-text-field", {
        attrs: {
          outlined: "",
          disabled: _vm.isLoading,
          value: _vm.value,
          "error-messages": _vm.errorMessage,
        },
        on: {
          change: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }